import { useTranslation } from 'react-i18next';

import { EventJournalModalQueries } from '@entities/eventJournal/model/queries';
import { useNuqsQueryState } from '@shared/hooks';

export const useEventJournalHeader = () => {
    const { t } = useTranslation();
    const { setState: setModalMode } = useNuqsQueryState(EventJournalModalQueries.queryName);
    const handleCreateEventBtn = async () => {
        await setModalMode(EventJournalModalQueries.queryCreate);
    };

    return {
        t,
        handleCreateEventBtn,
    };
};
